(ns humbleai.belt.malli.transform.default-value
  (:require
   [malli.core :as m]
   [malli.transform :as mt]))

;; Mostly copied from:
;; https://github.com/metosin/malli/blob/bf7d50bbef8feae11944bf8b094bfd600ed164e4/docs/tips.md?plain=1#L197
;; NOTE Uses `::fn` as the map prop key.
;; NOTE Currently only supports a decoder and the decoder is run in the `:leave` stage
(def transformer
  (let [add-defaults
        {:compile
         (fn [schema _]
           (let [->k-default (fn [[k {default-fn ::fn :keys [optional]} v]]
                               (when-not optional
                                 (when default-fn
                                   [k default-fn])))
                 defaults (into {}
                                (map ->k-default)
                                (m/children schema))
                 exercise (fn [x defaults]
                            (reduce-kv (fn [acc k v]
                                         ;; the key difference compare to default-value-transformer
                                         ;; we evaluate v instead of just passing it
                                         (if-not (contains? x k)
                                           (-> (assoc acc k ((m/eval v) x))
                                               (try
                                                 (catch #?(:clj Exception :cljs :default) _
                                                   acc)))
                                           acc))
                                       x defaults))]
             (when (seq defaults)
               {:leave
                (fn [x]
                  (if (map? x)
                    (exercise x defaults)
                    x))})))}]
    (mt/transformer
     mt/default-value-transformer
     {:decoders {:map add-defaults}})))
